import { PrefixedTextField, PrefixedTextFieldProps } from '@components/prefixed-text-field';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormPrefixedTextFieldProps<T = unknown> = FormFieldProps<PrefixedTextFieldProps, T>;

export function FormPrefixedTextField<T>(props: FormPrefixedTextFieldProps<T>) {
  const formFieldProps = useFormField(props);

  return <PrefixedTextField {...props} {...formFieldProps} />;
}
